import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import { useProject } from '../../../../context/ProjectContext'
import UITestsEmpty from './UITestsEmpty'
import PageBlocks from './PageBlocks'
import BlockScreenshotModal from './BlockScreenshotModal'
import { sortIssues } from '../../../../utils/sortIssues'

const UiTestingTab = ({ page, isScanLoading, handleScanPage, isGenerateTestsInProgress }) => {
  const navigate = useNavigate()
  const { selectedProject } = useProject()

  const [openBlockModal, setOpenBlockModal] = useState(false)
  const [selectedSection, setSelectedSection] = useState(null)
  const [selectedIssue, setSelectedIssue] = useState(null)
  const [fullPageBlock, setFullPageBlock] = useState(null)
  const [pageBlocks, setPageBlocks] = useState(null)

  useEffect(() => {
    if (page && selectedProject?.id && page.page.project_id !== selectedProject.id) {
      navigate(`/pages`)
    }
    setFullPageBlock(null)
    setPageBlocks(null)
    setSelectedSection(null)
    setSelectedIssue(null)

    if (page?.blocks.length) {
      setFullPageBlock(page.blocks[0])

      if (page?.blocks.length > 1) {
        const blocks = page.blocks.filter((pageBlock, index) => index > 0)
        setPageBlocks(blocks)
        setSelectedSection(blocks[0])
        if (blocks[0].Issues.length) {
          setSelectedIssue(sortIssues(blocks[0].Issues)[0])
        }
      } else if (page?.blocks.length === 1) {
        const blocks = page.blocks
        setPageBlocks(blocks)
        setSelectedSection(blocks[0])
        if (blocks[0].Issues.length) {
          setSelectedIssue(sortIssues(blocks[0].Issues)[0])
        }
      }
    }
  // eslint-disable-next-line
  }, [selectedProject?.id, page])

  const handleBlockModalOpen = () => setOpenBlockModal(true)
  const handleBlockModalClose = () => setOpenBlockModal(false)

  return (
    <Box className="uiTestingTabContentContainer">
      { page?.page?.summary
        ? <Typography variant="body1" color="primary" sx={{ mb: 2 }}>
          Summary: {page.page.summary}
        </Typography>
        : null
      }
      { page?.page.last_scanned_at && !page.page.issue_count
        ? <Typography variant="body1" color="success.main" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
          Great job! No UI issues were found on this page. Your UI is looking flawless!
          <CheckCircleOutlineOutlinedIcon sx={{ ml: 0.5, mb: 0.5, fontSize: '20px' }} />
        </Typography>
        : null
      }
      { !fullPageBlock && !pageBlocks && !page?.page?.last_scanned_at && !page?.page?.server_response
        ? <UITestsEmpty 
            isGenerateTestsInProgress={isGenerateTestsInProgress} 
            isScanLoading={isScanLoading} 
            handleScanPage={handleScanPage}
          />
        : null
      }
      { fullPageBlock
        ? <PageBlocks
          page={page}
          fullPageBlock={fullPageBlock}
          pageBlocks={pageBlocks}
          selectedSection={selectedSection}
          setSelectedSection={setSelectedSection}
          selectedIssue={selectedIssue}
          setSelectedIssue={setSelectedIssue}
          handleBlockModalOpen={handleBlockModalOpen}
        />
        : null
      }
      <BlockScreenshotModal
        openBlockModal={openBlockModal}
        handleBlockModalClose={handleBlockModalClose}
        fullPageBlock={fullPageBlock}
        selectedSection={selectedSection}
        selectedIssue={selectedIssue}
      />
    </Box>
  )
}

export default UiTestingTab